export function isOdd(num: number) {
  return num % 2;
}
